import { z } from 'zod';

export const verifyEmailChangeSchema = z.object({
  code: z
    .string()
    .length(6)
    .regex(/^\d{6}$/),
});

export type VerifyEmailChangePayload = z.infer<typeof verifyEmailChangeSchema>;
